export default __webpack_public_path__ + "assets/fonts/DMSans-SemiBold-0e4c.ttf";